/**
 * API Key Connector Component
 * Form component for API key authentication configuration
 */

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import type { UseFormReturn } from 'react-hook-form'

interface ApiKeyConnectorProps {
  form: UseFormReturn<any>
}

/**
 * API Key connector form component
 */
export function ApiKeyConnector({ form }: ApiKeyConnectorProps) {
  return (
    <FormField
      control={form.control}
      name="apiKey"
      render={({ field }) => (
        <FormItem className="mt-3 flex items-center">
          <FormLabel className="mr-2 flex h-[40px] w-1/3 items-center text-sm">
            API Key
          </FormLabel>
          <FormControl className="w-2/3">
            <Input
              value={field.value ?? ""}
              placeholder="Add your API Key"
              {...form.register("apiKey", {
                required: true,
              })}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}